module.exports = "img/photo32.89fa52.jpg";